import * as React from 'react';
import classNames from 'classnames';
import CtaFooter from 'blocks/layouts/CtaFooter';
import * as styles from './GenericPage.module.scss';
import Section from '../Section/Section';
import Title, { TitleProps } from '../Title';

export interface GenericPageProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    titleProps?: Partial<Omit<TitleProps, 'title' | 'subtitle'>>;
    noCtaFooter?: boolean;
    className?: string;
}

function GenericPage({
    title,
    subtitle,
    children,
    titleProps,
    noCtaFooter,
    className,
}: React.PropsWithChildren<GenericPageProps>): React.ReactElement {
    return (
        <>
            <Section classes={{ content: classNames(styles.root, className) }}>
                <Title
                    Component="h1"
                    title={title}
                    subtitle={subtitle}
                    {...titleProps}
                    className={classNames(styles.header, titleProps?.className)}
                />
                {children}
            </Section>
            {noCtaFooter || <CtaFooter />}
        </>
    );
}

export default GenericPage;
